export default __webpack_public_path__ + "static/media/Wristband of the Unutterable.bc756ea7.jpg";